/**
 * Utility functions for checking job taxonomy versions
 */

/**
 * Check if a version string represents v3 taxonomy
 */
export const isV3Taxonomy = (version: string | undefined): boolean => {
  if (!version) return false;

  // Check if it's a string version starting with 3
  return version.startsWith('3');
};
